import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import FilterBox from "./FilterBox";
import FilterItem from "../SidePanel/Components/FilterItem/FilterItem";
import { WerfenColor, White } from "../../Constants/ColorChart";
import { hidePanel, showPanel } from '../../../actions/ui'
import { refreshSearch } from '../../../actions/search'
import {
    addBUfilter,
    addDfilter,
    addFEfilter,
    addTypeFilter,
    addDateFilter,
    clearBUfilters,
    clearDfilters,
    clearFEfilters,
    clearTypeFilters,
    clearDateFilters,
    removeBUfilter,
    removeDfilter,
    removeFEfilter,
    removeTypeFilter,
    removeDateFilter,
} from '../../../actions/filters'
import { connect } from "react-redux";
import { SET_EXPANDED_BY_DEFAULT_MUTATION } from "../Profile/Components/SettingsSection/Queries/SettingsQueries";
import { Switch } from "../Profile/Components/SettingsSection/SettingsSection";
import { Col, Container, Row } from "react-bootstrap";
import { setSettings } from "../../../actions/settings";

const SidePanelComponent = styled.div`
    &.close{
        opacity: 1!important;
        .SidePanel {
        transform: translateX(100%);
        font-weight: normal;
        text-shadow: unset;
        color: inherit;
        font-size: unset;
        }
        
    } 
    .SidePanel{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0px;
        z-index: 1;
        background: ${ White };
        transition: all 0.5s ease-in-out;
        width: 100%;
        z-index: 1001;
        border-left: 4px solid ${ WerfenColor };
        background-clip: padding-box;
        transform: translateX(0);
          @media (min-width: 765px){
              width: 50%
              .close & {
                  transform: translate(-50%);
              }          
          }
          @media (min-width: 992px){
              width: 33%
              .close & {
                  transform: translate(-33%);
              }
          } 
          @media (min-width: 1200px){
              width: 25%
              .close & {
                  transform: translate(-25%);
              }
          } 
        .close & {
            transform: translateX(-100%);
        }
        & > div {
            position: relative;
        }
        &-header {
            padding: 16px 24px 17px 24px;
            background: ${ WerfenColor };
            height: 50px;
            h2 {
                color: ${ White };
                font-size: 16px;
                margin: 0;
            }
        }
        &-body {
            padding: 24px;
            position: absolute!important;
            top: 50px;
            bottom: 0;
            overflow-y: auto;
        }
        span.close-panel, span.clear-filters {
            position: absolute;
            right: 4px;
            margin-top: 4px;
            cursor: pointer;
        }
        span.close-panel {
            padding: 10px 20px;
            color: ${ White };
            top: 0
        }
        span.clear-filters {
            padding: 20px;
        }
        span.clear-filters {
            font-size: 12px;
        }
    }
`;

const StyledFilterLoader = styled.div`
    display: block;
    width: 80%;
    padding-bottom: 30px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    padding: 20px 5px;
    text-align: center
`;

const SidePanel = ( props ) => {
    const [ expandedByDefault, setExpandedByDefault ] = useState ( props.settings.expandedByDefault );
    const {
        BUfilterArray,
        businessUnits,
        DfilterArray,
        departments,
        FEfilterArray,
        fileExtensions,
        TypeFilterArray,
        types,
        DateFilterArray,
        dates,
        datesMap,
    } = props;
    const businessLines = businessUnits || [];
    const departmentFilters = departments || [];
    const fileExtensionFilters = fileExtensions || [];
    const typeFilters = types || [];
    const dateFilters = dates || [];
    const dateFiltersMap = datesMap || {};
    const loadingBU = businessUnits === undefined;
    const loadingDEPTS = departments === undefined;
    const loadingFE = fileExtensions === undefined;

    useEffect ( () => {
        const settings = {
            expandedByDefault,
        }
        props.setSettings ( settings );

       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ expandedByDefault ] );

    const toggleFilter = ( data, callback ) => {
        const { event, type, filter } = data;
        event.preventDefault();

        let filterArray = BUfilterArray;
        let add = props.addBUfilter;
        let remove = props.removeBUfilter;

        if ( type === "department" ) {
            filterArray = DfilterArray;
            add = props.addDfilter;
            remove = props.removeDfilter;
        } else if ( type === "file-extensions" ) {
            filterArray = FEfilterArray;
            add = props.addFEfilter;
            remove = props.removeFEfilter;
        } else if ( type === "type" ) {
            filterArray = TypeFilterArray;
            add = props.addTypeFilter;
            remove = props.removeTypeFilter;
        } else if ( type === "date" ) {
            filterArray = DateFilterArray;
            add = props.addDateFilter;
            remove = props.removeDateFilter;
        }

        const index = filterArray.indexOf( filter );

        if ( index === -1 ) {
            add( filter );
        } else {
            remove( filter );
        }

        callback();
    }

    const clearFilterArray = ( data ) => {
        const { type } = data;
        let clear = props.clearBUfilters;

        if ( type === "department" ) {
            clear = props.clearDfilters;
        } else if ( type === "file-extensions" ) {
            clear = props.clearFEfilters;
        } else if ( type === "type" ) {
            clear = props.clearTypeFilters;
        } else if ( type === "date" ) {
            clear = props.clearDateFilters;
        }

        clear();
        props.refreshSearch()

    }

    return (
        <SidePanelComponent className={ props.showSidePanel ? "open" : "close" }>
            <div className="SidePanel">
                <div className="SidePanel-header">
                    <h2>Settings</h2>
                    <span
                        className="close-panel"
                        onClick={ props.hidePanel }
                    >✕</span>
                </div>
                <div className="SidePanel-body">
                    {
                        <Container>
                            <Row>
                                <Col
                                    xs={10}
                                    className={'text-start'}
                                >
                                    <p>Expand descriptions by default</p>
                                </Col>
                                <Col
                                    xs={2}
                                    className={'text-end'}
                                >
                                    <Switch
                                        option={expandedByDefault}
                                        setOption={setExpandedByDefault}
                                        mutation={SET_EXPANDED_BY_DEFAULT_MUTATION}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    }
                    <hr className="SidePanel-body-separator"/>
                    {
                        businessLines &&
                        businessLines.length > 1 &&
                        BUfilterArray.length > 0 &&
                        <span className="clear-filters"
                              onClick={() => {
                                  clearFilterArray({
                                      type: "business-units"
                                  })
                              }}
                        >✕ Reset</span>
                    }
                    {
                        loadingBU &&
                        <StyledFilterLoader>LOADING BUSINESS UNIT FILTERS</StyledFilterLoader>
                    }
                    {
                        !loadingBU && businessLines.length > 1 &&
                        <FilterBox hint={process.env.REACT_APP_BUSINESS_UNITS_LABEL || "Filter Business Units"}>
                            {
                                businessLines.map((item, index) => {
                                    const {text, icon, value} = item;
                                    return (
                                        <FilterItem
                                            key={index}
                                            text={text}
                                            icon={icon === null ? text.substring(0, 2).toUpperCase() : icon}
                                            origin={"topbar"}
                                            onClick={(event) => {
                                                toggleFilter({
                                                        event: event,
                                                        type: "business-units",
                                                        filter: value,
                                                    },
                                                    props.refreshSearch
                                                )
                                            }}
                                            value={value}
                                            active={BUfilterArray.includes(value)}/>
                                    )
                                })
                            }
                        </FilterBox>
                    }
                    {
                        businessLines &&
                        businessLines.length > 1 &&
                        departmentFilters &&
                        departmentFilters.length > 1 &&
                        <hr className="SidePanel-body-separator"/>
                    }
                    {/**/}
                    {
                        departmentFilters &&
                        departmentFilters.length > 1 &&
                        DfilterArray.length > 0 &&
                        <span className="clear-filters"
                              onClick={() => {
                                  clearFilterArray({
                                      type: "department"
                                  })
                              }}
                        >✕ Reset</span>
                    }
                    {
                        loadingDEPTS &&
                        <StyledFilterLoader>LOADING DEPARTMENT FILTERS</StyledFilterLoader>
                    }
                    {
                        !loadingDEPTS && departmentFilters.length > 1 &&
                        <FilterBox hint={process.env.REACT_APP_DEPARTMENTS_LABEL || "Filter Departments"}>
                            {
                                departmentFilters.map((item, index) => {
                                    const {text, icon, value} = item;
                                    return (
                                        <FilterItem
                                            key={index}
                                            text={text}
                                            icon={icon === null ? text.substring(0, 2).toUpperCase() : icon}
                                            origin={"topbar"}
                                            onClick={(event) => {
                                                toggleFilter({
                                                        event: event,
                                                        type: "department",
                                                        filter: value,
                                                    },
                                                    props.refreshSearch
                                                )
                                            }}
                                            value={value}
                                            active={DfilterArray.includes(value)}/>
                                    )
                                })
                            }
                        </FilterBox>
                    }
                    {
                        departmentFilters &&
                        departmentFilters.length > 1 &&
                        fileExtensionFilters &&
                        fileExtensionFilters.length > 1 &&
                        <hr className="SidePanel-body-separator"/>
                    }
                    {/**/}
                    {
                        fileExtensionFilters &&
                        fileExtensionFilters.length > 1 &&
                        FEfilterArray.length > 0 &&
                        <span className="clear-filters"
                              onClick={() => {
                                  clearFilterArray({
                                      type: "file-extensions"
                                  })
                              }}
                        >✕ Reset</span>
                    }
                    {
                        loadingFE &&
                        <StyledFilterLoader>LOADING FILE EXTENSION FILTERS</StyledFilterLoader>
                    }
                    {
                        !loadingFE && fileExtensionFilters.length > 1 &&
                        <FilterBox hint={process.env.REACT_APP_FILE_EXTENSIONS_LABEL || "Filter File Extensions"}>
                            {
                                fileExtensionFilters.map((item, index) => {
                                    // const { text, icon, value } = item;
                                    const text = item;
                                    const icon = null;
                                    const value = item.toLowerCase();

                                    return (
                                        <FilterItem
                                            key={index}
                                            text={text}
                                            icon={icon === null ? text.substring(0, 2).toUpperCase() : icon}
                                            origin={"topbar"}
                                            onClick={(event) => {
                                                toggleFilter({
                                                        event: event,
                                                        type: "file-extensions",
                                                        filter: value,
                                                    },
                                                    props.refreshSearch
                                                )
                                            }}
                                            value={value}
                                            active={FEfilterArray.includes(value)}
                                        />
                                    )
                                })
                            }
                        </FilterBox>
                    }
                    <hr className="SidePanel-body-separator"/>
                    {
                        TypeFilterArray.length > 0 &&
                        <span className="clear-filters"
                              onClick={() => {
                                  clearFilterArray({
                                      type: "type"
                                  })
                              }}
                        >✕ Reset</span>
                    }
                    <FilterBox hint={process.env.REACT_APP_TYPE_LABEL || "Type"}>
                        {
                            typeFilters.map((item, index) => {
                                const text = item;
                                const value = item.toLowerCase();

                                return (
                                    <FilterItem
                                        key={index}
                                        text={text}
                                        origin={"topbar"}
                                        onClick={(event) => {
                                            toggleFilter(
                                                {
                                                    event: event,
                                                    type: "type",
                                                    filter: value,
                                                },
                                                props.refreshSearch
                                            )
                                        }}
                                        value={value}
                                        active={TypeFilterArray.includes(value)}
                                    />
                                )
                            })
                        }
                    </FilterBox>
                    <hr className="SidePanel-body-separator"/>
                    {
                        DateFilterArray.length > 0 &&
                        <span className="clear-filters"
                              onClick={() => {
                                  clearFilterArray({
                                      type: "date"
                                  })
                              }}
                        >✕ Reset</span>
                    }
                    <FilterBox hint={process.env.REACT_APP_DATE_LABEL || "Date"}>
                        {
                            dateFilters.map((item, index) => {
                                const text = dateFiltersMap[item];
                                const value = item.toLowerCase();

                                return (
                                    <FilterItem
                                        key={index}
                                        text={text}
                                        origin={"topbar"}
                                        onClick={(event) => {
                                            toggleFilter(
                                                {
                                                    event: event,
                                                    type: "date",
                                                    filter: value,
                                                },
                                                props.refreshSearch
                                            )
                                        }}
                                        value={value}
                                        active={DateFilterArray.includes(value)}
                                    />
                                )
                            })
                        }
                    </FilterBox>
                    <hr className="SidePanel-body-separator"/>
                </div>
            </div>
        </SidePanelComponent>
    )
}

const mapStateToProps = ( state ) => (
    {
        showSidePanel: state.ui.showSidePanel,
        BUfilterArray: state.filters.BUfilterArray,
        DfilterArray: state.filters.DfilterArray,
        FEfilterArray: state.filters.FEfilterArray,
        TypeFilterArray: state.filters.TypeFilterArray,
        DateFilterArray: state.filters.DateFilterArray,
        businessUnits: state.settings.businessUnits,
        departments: state.settings.departments,
        fileExtensions: state.settings.fileExtensions,
        types: state.settings.types,
        dates: state.settings.dates,
        datesMap: state.settings.datesMap,
        settings: state.settings,
    })

export default connect( mapStateToProps, {
    hidePanel,
    showPanel,
    refreshSearch,
    addBUfilter,
    setSettings,
    removeBUfilter,
    clearBUfilters,
    addDfilter,
    removeDfilter,
    clearDfilters,
    addFEfilter,
    removeFEfilter,
    clearFEfilters,
    addTypeFilter,
    removeTypeFilter,
    clearTypeFilters,
    addDateFilter,
    removeDateFilter,
    clearDateFilters,
} )( SidePanel );